import React, { Component } from 'react';
import { Input, Select, DatePicker, TimePicker, Checkbox } from 'antd';
import { dateFormat, timeFormat } from '../../lib/DateFormat';
import moment from 'moment-business-days';
import FormItem from 'antd/lib/form/FormItem';
import { connect } from 'react-redux';
import { getAppointmentEvents, getMyAppointments } from '../../actions';
import { isTelemarketer } from '../../lib/AuthUtils';
import { SELLER_TELEMARKETER_TIME_WORK } from '../../constants/SellerConstants';

const SelectOption = Select.Option;
const { TextArea } = Input;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

// prefix string to form the i18n key
const I18N_PREFIX = 'APPOINTMENT_';
const I18N_PREFIX_LOWER = I18N_PREFIX.toLowerCase();

class AppointmentFormCart extends Component {
    constructor(props) {
        super(props);


        this.state = this.getInitialState();
    }

    getInitialState = () => ({
        // Shows the create form by default if user is admin or seller
        selectTypeAppointment: this.props.isSalesman || this.props.isAdmin ? 'Create' : null,
        appointment_event: this.props.appointment_event || null,
        appointmentDate: moment(),
        commentary: null,
        collection: this.props.collection || false,
        detail: null,
        appointmentSelectedId: null,
    });

    componentDidMount() {
        const params = {
            clientId: this.props.order.clienteId,
            dateFrom: moment().subtract(4, 'week').startOf('day').format('YYYY-MM-DD'),
            dateTo: moment().endOf('day').format('YYYY-MM-DD'),
        };
        this.props.getMyAppointments(params);
        this.props.getAppointmentEvents();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.appointment_event !== this.props.appointment_event) {
            this.setState(this.getInitialState());
        }
    }

    onSetTypeAppointment = (value) => {
        const newState = { selectTypeAppointment: value };

        if (newState.selectTypeAppointment === 'Create') {
            newState.appointmentSelectedId = null;
            this.props.handleSelectAppointmentId();
        }

        this.setState(newState);
    };

    onSetEventTypeAppointment = (value) => {
        const newEvent = { appointment_event: value };
        this.setState(newEvent);
    };

    onSetAppointment = (value) => {
        this.setState({
            appointmentSelectedId: value,
        });
    };

    disableHours = () => {
        if (isTelemarketer(this.props.auth)) {
            return SELLER_TELEMARKETER_TIME_WORK.DISABLED_HOURS;
        } else {
            return [];
        }
    };

    disableMinutes = (hours) => {
        let minutes = [];
        if (isTelemarketer(this.props.auth) && hours === 17) {
            for (let i = 1; i < 60; i++) {
                minutes.push(i);
            }
            return minutes;
        } else {
            return minutes;
        }
    };

    render() {
        const {
            t,
            appointmentList,
            isSalesman,
            handleSetStateChange,
            start_dateTime,
            events,
            errors,
            auth,
            isAdmin,
        } = this.props;
        const {
            selectTypeAppointment,
            appointmentDate,
            commentary,
            appointmentSelectedId,
            detail,
            collection,
            appointment_event
        } = this.state;

        let startDateTime;
        if (start_dateTime) {
            startDateTime = start_dateTime;
        } else {
            if (isTelemarketer(auth)) {
                const startInterval = SELLER_TELEMARKETER_TIME_WORK.FROM();
                const endInterval = SELLER_TELEMARKETER_TIME_WORK.TO().subtract(1, 'h');
                const midNight = SELLER_TELEMARKETER_TIME_WORK.MIDNIGHT();

                if (moment().isSameOrAfter(midNight) && moment().isBefore(startInterval)) {
                    startDateTime = startInterval;
                    handleSetStateChange('start_dateTime', startDateTime);
                }
                if (
                    moment().isAfter(midNight) &&
                    (moment().isAfter(endInterval) || moment().add(1, 'h').isAfter(endInterval))
                ) {
                    startDateTime = endInterval;
                    handleSetStateChange('start_dateTime', startDateTime);
                }
                if (moment().isBetween(startInterval, endInterval, undefined, '[]')) {
                    startDateTime = moment();
                    handleSetStateChange('start_dateTime', startDateTime);
                }
            } else {
                handleSetStateChange('start_dateTime', moment());
            }
        }

        return (
            <div>
                {(isSalesman || isAdmin) && (
                    <div className="name-input">
                        <FormItem {...formItemLayout} label={t('State')}>
                            <Select
                                value={t(I18N_PREFIX + selectTypeAppointment)}
                                name="typeAppointment"
                                style={{ width: 200 }}
                                onChange={(value) => {
                                    handleSetStateChange('selectTypeAppointment', value);
                                    this.onSetTypeAppointment(value);
                                }}
                            >
                                {['Create', 'Associate'].map((value) => (
                                    <SelectOption value={value} key={value}>
                                        {t(I18N_PREFIX + value)}
                                    </SelectOption>
                                ))}
                            </Select>
                        </FormItem>
                    </div>
                )}
                {selectTypeAppointment === 'Create' && (
                    <div className="name-input">
                        <FormItem {...formItemLayout} label={t('EVENT_TYPE')}>
                            <Select
                                name="event"
                                style={{ width: 150 }}
                                value={appointment_event}
                                onChange={(value) => {
                                    handleSetStateChange('appointment_event', value);
                                    this.onSetEventTypeAppointment(value);
                                }}
                            >
                                {events
                                    ? Object.keys(events).map((value) => (
                                        <SelectOption value={value} key={value}>
                                            {t(I18N_PREFIX_LOWER + value)}
                                        </SelectOption>
                                    ))
                                    : ''}
                            </Select>
                        </FormItem>
                    </div>
                )}
                {selectTypeAppointment === 'Create' && (
                    <div className="name-input">
                        <FormItem {...formItemLayout} label={t('Date')}>
                            <DatePicker
                                id="appointmentDate"
                                format={dateFormat}
                                name="appointmentDate"
                                value={appointmentDate ? moment(appointmentDate) : moment()}
                                onChange={(value) => {
                                    this.setState({ appointmentDate: value });
                                    handleSetStateChange('appointmentDate', value);
                                }}
                                allowClear={false}
                                placeholder={t('Select date')}
                            />
                        </FormItem>
                    </div>
                )}
                {selectTypeAppointment === 'Create' && (
                    <div className="name-input">
                        <FormItem {...formItemLayout} label={t('Start time')}>
                            <TimePicker
                                placeholder={t('Start time')}
                                value={startDateTime}
                                format={timeFormat}
                                disabledHours={this.disableHours}
                                disabledMinutes={this.disableMinutes}
                                onChange={(value) => {
                                    if (isTelemarketer(auth) && value.hour() === 17) {
                                        value.minute(0);
                                    }
                                    handleSetStateChange('start_dateTime', value);
                                }}
                                allowClear={false}
                            />
                        </FormItem>
                    </div>
                )}
                {selectTypeAppointment === 'Create' && (
                    <div className="name-input">
                        <FormItem {...formItemLayout} label={t('appointment_collection')}>
                            <Checkbox
                                checked={collection}
                                format={timeFormat}
                                onChange={(value) => {
                                    this.setState({ collection: value.target.checked });
                                    handleSetStateChange('collection', value.target.checked);
                                }}
                            />
                        </FormItem>
                    </div>
                )}
                {selectTypeAppointment === 'Create' && collection === true && (
                    <div className="name-input">
                        <FormItem
                            {...formItemLayout}
                            className={errors.detail ? 'has-error' : ''}
                            label={t('Details')}
                        >
                            <Input
                                value={detail}
                                name="detail"
                                type="text"
                                onChange={(value) => {
                                    this.setState({ detail: value.target.value });
                                    handleSetStateChange('detail', value.target.value);
                                }}
                            />
                            {errors.detail && (
                                <div className="ant-form-explain has-error">{errors.detail}</div>
                            )}
                        </FormItem>
                    </div>
                )}
                {selectTypeAppointment === 'Create' && (
                    <div className="name-input">
                        <FormItem label={t('Commentary')}>
                            <TextArea
                                rows={4}
                                value={commentary}
                                name="commentary"
                                placeholder={t('Commentary')}
                                onChange={(value) => {
                                    this.setState({ commentary: value.target.value });
                                    handleSetStateChange('commentary', value.target.value);
                                }}
                            />
                        </FormItem>
                    </div>
                )}
                {selectTypeAppointment === 'Associate' && (
                    <div className="name-input">
                        <FormItem {...formItemLayout} label={t('Select appointment')}>
                            <Select
                                value={appointmentSelectedId}
                                name="appointmentSelectedId"
                                style={{ width: 230 }}
                                onChange={(value) => {
                                    this.onSetAppointment(value);
                                    handleSetStateChange('appointmentSelectedId', value);
                                }}
                            >
                                {appointmentList.map((value) => (
                                    <SelectOption value={value.data.id} key={value.id}>
                                        {value.title}
                                    </SelectOption>
                                ))}
                            </Select>
                        </FormItem>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ appointment, auth }) => {
    const { appointmentEvents, monthEvents } = appointment;
    return {
        auth,
        events: appointmentEvents,
        appointmentList: monthEvents,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getAppointmentEvents: () => {
        dispatch(getAppointmentEvents());
    },
    getMyAppointments: (params) => {
        dispatch(getMyAppointments(params));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentFormCart);
